import React, { useState, useRef, useCallback } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { useIsomorphicLayoutEffect } from '@lib/hooks/useIsomorphicLayoutEffect';
import { inject, observer } from 'mobx-react';
import DetailLayout from '@components/DetailLayout';
import styles from '@styleModules/post/details.module.css';
import I18n from '@utils/i18n';
import { getClient } from '@api/feedStream';
import Details from '@widget/post/Details/index';
import helper from '@utils/helper';
import ActionGroup from '@widget/post/Details/Components/ActionGroup';
import useClient from '@lib/hooks/useClient';

import { BackTop } from '@element/index';
import { useLike } from '@widget/post/hooks/like';
import { useFav } from '@widget/post/hooks/fav';
import ProfileMessage from '@widget/post/Details/Components/ProfileMessage';
import Head from 'next/head';
const summaryReg =
  /<img[^>]*>|<video[^>]*>|<\/video[^>]*>|<source[^>]*>|<p[^>]*>|<br[^>]*>/g;
const QUERY_LIMIT = 10;

const T = (props) => {
  const commentInputRef = useRef(null);
  const nextIdRef = useRef('');
  const isPc = useClient();

  const router = useRouter();
  const { query } = router;
  const id = query.id;
  const { userStore, itemData: postData } = props;
  console.log(postData, 'postData', postData.topicContent);
  // const [postData, setPostData] = useState({});
  // console.log(postData, 'postData')
  const [comments, setComments] = useState([]);
  const commentsRef = useRef(comments);
  const [moreStatus, setMoreStatus] = useState(true);

  const [curLikeCount, setCurLikeCount] = useState(postData.likeCount);
  const [isLoved, setIsLoved] = useState(postData.like);
  const [curShareCount, setCurShareCount] = useState(postData.shareCount);
  const [curFavCount, setCurFavCount] = useState(postData.favoriteCount);
  const [isFav, setIsFav] = useState(postData.favorite);
  const [commentCount, setCommentCount] = useState(postData.commentCount);

  const { like } = useLike({
    userStore,
    itemData: postData,
    setCurLikeCount,
    setIsLoved,
    isLoved,
    curLikeCount
  });
  const { onFavoirite } = useFav({
    itemData: postData,
    setCurFavCount,
    setIsFav,
    isFav,
    curFavCount
  });
  useIsomorphicLayoutEffect(() => {
    setCurLikeCount(postData.likeCount);
    setIsLoved(postData.like);
    setCurShareCount(postData.shareCount);
    setCurFavCount(postData.favoriteCount);
    setIsFav(postData.favorite);
    setCommentCount(postData.commentCount);
  }, [postData]);

  // const fetchPostFeed = async (opt) => {
  //   const feedParamUser = 'post';
  //   const feedParamType = 'square';
  //   const queryParam = {
  //     id_lte: opt.id,
  //     id_gte: opt.id
  //   };
  //   const data = await getClient()
  //     .feed(feedParamUser, feedParamType)
  //     .get(queryParam)
  //   if (data.result) {
  //     const itemData = data.result;
  //     itemData.textObj = helper.parseHTMLString(itemData.text.replace(/<p><br><\/p>/g, '<br><br>'))
  //     setPostData(data.result);
  //   }
  // }

  const fetchPostComment = async (opt, callback) => {
    const query = {
      activity_id: opt.id,
      kind: 'COMMENT',
      limit: QUERY_LIMIT,
      id_lte: opt.nextId
    };
    const data = await getClient().reactions.filter(query);

    if (data.result) {
      commentsRef.current =
        opt && opt.loadMore
          ? [...commentsRef.current, ...data.result]
          : data.result;
      setComments(commentsRef.current);
      nextIdRef.current = data.nextId;
      setMoreStatus('success');
      callback && callback();
    }
  };
  const handleScroll = () => {
    window.scrollTo({
      top: commentInputRef.current?.offsetTop,
      left: 0,
      behavior: 'smooth'
    });
    commentInputRef.current?.focus({
      cursor: 'end'
    });
  };

  const fetchMoreComment = useCallback((options, callback) => {
    if (nextIdRef.current) {
      setMoreStatus('loading');
      fetchPostComment({ id, loadMore: true, nextId: nextIdRef.current });
    }
  });
  // console.log(loading)
  useIsomorphicLayoutEffect(() => {
    if (id) {
      // fetchPostFeed({ id });
      fetchPostComment({ id });
    }
  }, [id]);

  return (
    <DetailLayout
      title={I18n.t('community')}
      contentClass={styles.contentClass}
    >
      <Head>
        <title>
          {I18n.t('community_t', {
            title: postData.title
              ? `${postData.title}｜${postData?.customerMisc.nickName}`
              : postData?.customerMisc.nickName
          })}
        </title>
        <meta
          property="og:title"
          content={`${postData?.text?.replace(summaryReg, '').slice(0, 300)}`}
          key="title"
          name="description"
        />
      </Head>
      <div className={cn(styles.container)}>
        <div className={cn(styles.card, styles.LeftPart)}>
          <Details
            itemData={postData}
            comments={comments}
            type="" // todo
            squareType="" // todo
            curLikeCount={curLikeCount}
            isLoved={isLoved}
            likeFun={like}
            commentInputRef={commentInputRef}
            fetchPostComment={fetchPostComment}
            fetchMoreComment={fetchMoreComment}
            moreStatus={moreStatus}
            commentCount={commentCount}
            setCommentCount={setCommentCount}
          />
        </div>
        <div className={cn(styles.rightPart)}>
          <div className={cn(styles.card, styles.userInfoContainer)}>
            <ProfileMessage
              itemData={postData}
              userId={userStore.userInfo.id}
            />
          </div>
        </div>
        {!!isPc && (
          <ActionGroup
            itemData={postData}
            // 点赞
            curLikeCount={curLikeCount}
            isLoved={isLoved}
            likeFun={like}
            // 分享
            curShareCount={curShareCount}
            setCurShareCount={setCurShareCount}
            // 收藏
            curFavCount={curFavCount}
            isFav={isFav}
            favFun={onFavoirite}
            // 评论
            commentFun={handleScroll}
            commentCount={commentCount}
            // setCommentCount={setCommentCount}
          />
        )}
        <BackTop />
      </div>
    </DetailLayout>
  );
};

export default inject((rootStore) => {
  return {
    userStore: rootStore.store.userStore
  };
})(observer(T));

export async function getServerSideProps ({ query, req, res }) {
  const { jwt } = req.cookies || {};
  // https://nextjs.org/docs/going-to-production#caching
  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );
  const feedParamUser = 'post';
  const feedParamType = 'square';
  const { id } = query;
  let deCodeBase64;
  try {
    // create a buffer
    const buff = Buffer.from(id, 'base64');
    deCodeBase64 = buff.toString('utf-8');
  } catch (error) {
    // 中文情况
    return {
      redirect: {
        destination: `https://www.web.kikitrade.com/post/${encodeURI(id)}`,
        permanent: true
      }
    };
  }
  // 其余字符
  if (deCodeBase64.indexOf('POST:') < 0) {
    return {
      redirect: {
        destination: `https://www.web.kikitrade.com/post/${encodeURI(id)}`,
        permanent: true
      }
    };
  }
  let itemData = {};
  const queryParam = {
    id_lte: id,
    id_gte: id
  };
  const data = await getClient(jwt)
    .feed(feedParamUser, feedParamType)
    .get(queryParam);
  if (data.result) {
    itemData = data.result;
    itemData.textObj = helper.parseHTMLString(
      itemData.text.replace(/<p><br><\/p>/g, '<br><br>')
    );
  }
  return { props: { itemData } };
}
